
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  GetSkillsResponse,
  SimpleError,
  UpdateIndustryExpertisesRequest,
  UpdateProfileFunctionalSkillsRequest,
  UpdateProfileGlobalSkillsRequest,
  UpdateProfileRemainingSkillsRequest,
  UpdateProfileSkillsRequest,
  UpdateProfileTopSkillsRequest,
} from '../models';
import {
    GetSkillsResponseFromJSON,
    GetSkillsResponseToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    UpdateIndustryExpertisesRequestFromJSON,
    UpdateIndustryExpertisesRequestToJSON,
    UpdateProfileFunctionalSkillsRequestFromJSON,
    UpdateProfileFunctionalSkillsRequestToJSON,
    UpdateProfileGlobalSkillsRequestFromJSON,
    UpdateProfileGlobalSkillsRequestToJSON,
    UpdateProfileRemainingSkillsRequestFromJSON,
    UpdateProfileRemainingSkillsRequestToJSON,
    UpdateProfileSkillsRequestFromJSON,
    UpdateProfileSkillsRequestToJSON,
    UpdateProfileTopSkillsRequestFromJSON,
    UpdateProfileTopSkillsRequestToJSON,
} from '../models';

export interface GetSkillsFromProfileIdRequest {
    profileId: string;
}

export interface UpdateFunctionalSkillsRequest {
    updateProfileFunctionalSkillsRequest: UpdateProfileFunctionalSkillsRequest;
}

export interface UpdateGlobalSkillsRequest {
    updateProfileGlobalSkillsRequest: UpdateProfileGlobalSkillsRequest;
}

export interface UpdateIndustryExpertisesOperationRequest {
    updateIndustryExpertisesRequest: UpdateIndustryExpertisesRequest;
}

export interface UpdateRemainingSkillsRequest {
    updateProfileRemainingSkillsRequest: UpdateProfileRemainingSkillsRequest;
}

export interface UpdateSkillsRequest {
    updateProfileSkillsRequest: UpdateProfileSkillsRequest;
}

export interface UpdateTopSkillsRequest {
    updateProfileTopSkillsRequest: UpdateProfileTopSkillsRequest;
}

/**
 * 
 */
export class ExpertiseApi extends runtime.BaseAPI {

    /**
     * Get skills of connected user
          */
    async getSkillsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<GetSkillsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<GetSkillsResponse>({
            path: `/profile/api/expertises/skills`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=GetSkillsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get skills of connected user
          */
    async getSkills(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<GetSkillsResponse> {
        const response = await this.getSkillsRaw(initOverrides);
        return response._data;
    }

    /**
     * List skills of a given profile
          */
    async getSkillsFromProfileIdRaw(requestParameters: GetSkillsFromProfileIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<GetSkillsResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getSkillsFromProfileId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<GetSkillsResponse>({
            path: `/profile/api/profiles/{profileId}/expertises/skills`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=GetSkillsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * List skills of a given profile
          */
    async getSkillsFromProfileId(requestParameters: GetSkillsFromProfileIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<GetSkillsResponse> {
        const response = await this.getSkillsFromProfileIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update functional skills of connected user
          */
    async updateFunctionalSkillsRaw(requestParameters: UpdateFunctionalSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateProfileFunctionalSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileFunctionalSkillsRequest',
                'Required parameter "updateProfileFunctionalSkillsRequest" was null or undefined when calling updateFunctionalSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/functional-skills`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileFunctionalSkillsRequestToJSON(requestParameters['updateProfileFunctionalSkillsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update functional skills of connected user
          */
    async updateFunctionalSkills(requestParameters: UpdateFunctionalSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateFunctionalSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update global skills of connected user
          */
    async updateGlobalSkillsRaw(requestParameters: UpdateGlobalSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateProfileGlobalSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileGlobalSkillsRequest',
                'Required parameter "updateProfileGlobalSkillsRequest" was null or undefined when calling updateGlobalSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/global-skills`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileGlobalSkillsRequestToJSON(requestParameters['updateProfileGlobalSkillsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update global skills of connected user
          */
    async updateGlobalSkills(requestParameters: UpdateGlobalSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateGlobalSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update industry expertises of connected user
          */
    async updateIndustryExpertisesRaw(requestParameters: UpdateIndustryExpertisesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateIndustryExpertisesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIndustryExpertisesRequest',
                'Required parameter "updateIndustryExpertisesRequest" was null or undefined when calling updateIndustryExpertises().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/industry`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIndustryExpertisesRequestToJSON(requestParameters['updateIndustryExpertisesRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update industry expertises of connected user
          */
    async updateIndustryExpertises(requestParameters: UpdateIndustryExpertisesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateIndustryExpertisesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update remaining skills of connected user
          */
    async updateRemainingSkillsRaw(requestParameters: UpdateRemainingSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateProfileRemainingSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileRemainingSkillsRequest',
                'Required parameter "updateProfileRemainingSkillsRequest" was null or undefined when calling updateRemainingSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/remaining-skills`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileRemainingSkillsRequestToJSON(requestParameters['updateProfileRemainingSkillsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update remaining skills of connected user
          */
    async updateRemainingSkills(requestParameters: UpdateRemainingSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateRemainingSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update skills of connected user
          */
    async updateSkillsRaw(requestParameters: UpdateSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateProfileSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileSkillsRequest',
                'Required parameter "updateProfileSkillsRequest" was null or undefined when calling updateSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/skills`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileSkillsRequestToJSON(requestParameters['updateProfileSkillsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update skills of connected user
          */
    async updateSkills(requestParameters: UpdateSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update top skills of connected user
          */
    async updateTopSkillsRaw(requestParameters: UpdateTopSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<object>> {
        if (requestParameters['updateProfileTopSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProfileTopSkillsRequest',
                'Required parameter "updateProfileTopSkillsRequest" was null or undefined when calling updateTopSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<object>({
            path: `/profile/api/expertises/top-skills`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileTopSkillsRequestToJSON(requestParameters['updateProfileTopSkillsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update top skills of connected user
          */
    async updateTopSkills(requestParameters: UpdateTopSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.updateTopSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
